module.exports = __webpack_public_path__ + "static/media/category20.5521692c.png";